import { useEffect } from 'react';

// Sets the browser tab/bookmark title for whichever top-level page calls
// this — every route used to share the one static <title> from index.html
// ("OSSDF Scoring"), which made it impossible to tell portals/tabs apart.
// Restores the previous title on unmount so navigating away (e.g. a
// same-tab redirect) doesn't leave a stale title behind.
export default function usePageTitle(title) {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => { document.title = previous; };
  }, [title]);
}
